module.exports = __webpack_public_path__ + "static/media/logo-1.7bb501ad.png";